<template>
  <div style="padding: 0 20px">
<!--    <h1>宜家移动应用使用条款</h1>-->
<!--    <p>宜家移动应用（简称“本应用”）包括手机应用程序（App）、微信小程序。本协议是您与本应用经营者（以下简称为“宜家”）之间就产品和服务销售等相关事宜所订立的契约，请您仔细阅读本服务协议，务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。您点击“同意并继续”按钮后，即视为您完全接受本协议并构成对双方约束力的法律文件，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。本协议中未明确授权的其他权利仍由宜家保留，您在行使该权利时必须另行取得宜家许可。如果宜家未行使下述任何权利，并不构成对该权利的放弃。</p>-->
<!--    <h3>1. 隐私政策</h3>-->
<!--    <p>本移动应用适用《宜家中国隐私政策》。</p>-->
<!--    <h3>2. 使用条款</h3>-->
<!--    <p>2.1 关于使用条款</p>-->
<!--    <p>使用条款是宜家移动应用的固定部分。当您访问本应用时，本条款将完全适用。</p>-->
<!--    <p>若不同意本条款，请立即停止使用宜家移动应用。</p>-->
<!--    <p>如中英文版本有任何不一致之处，概以中文版为准。</p>-->
<!--    <p>2.2 您的个人隐私信息保护及授权</p>-->
<!--    <p>2.2.1 您知悉并同意，为方便您使用本应用相关服务，宜家将存储您在使用时的必要信息，包括但不限于您的真实姓名、性别、生日、配送地址、联系方式、定位信息等。除法律法规规定的情形外，未经您的许可本应用不会向第三方公开、透露您的个人信息。</p>-->
<!--    <p>2.2.2 您在注册帐号或使用本应用的过程中，需要提供真实的身份信息，宜家将根据国家法律法规相关要求，进行基于移动电话号码的真实身份信息认证。若您提供的信息不真实、不完整，则无法使用本应用或在使用过程中受到限制，同时，由此产生的不利后果，由您自行承担。</p>-->
<!--    <p>2.2.3 您在使用本应用某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“相关协议”），您在使用该项服务前请阅读并同意相关协议；您使用前述特定服务，即视为您已阅读并同意接受相关协议。</p>-->
<!--    <p>2.3 本应用上的信息</p>-->
<!--    <p>我们将尽全力确保我们的应用始终正常运作，但是我们不能保证应用在所有时间的可用性和可访问性，另外（除非本协议另有所述），对于您因无法使用或访问本应用而产生的任何损坏、损失、成本或费用，我们将不对此承担责任。在网上订单支付确认之前，如果我们的价格标注有误，我们有权修改价格，且不会根据您在应用上最初看到的价格向您出售产品。</p>-->
<!--    <p>2.4 链接和分享</p>-->
<!--    <p>本应用的任何链接或分享机会（通过社交媒体、博客以及类似应用和通信服务）仅出于方便您使用的目的而提供。此类链接并不表示受到我们的认可与推荐，也不意味着我们与链接的应用有任何关联。对于和本应用相互链接的任何应用上的内容，以及对于您与提供此类链接应用的第三方签订的任何合同的法律后果，我们将不对此承担责任，对于您因此而产生的任何损失、损坏、费用、成本或责任，我们同样不承担责任。</p>-->
<!--    <p>请注意，如果您的确在其他平台分享了任何内容，其他组织可能也另制定了允许您进行分享的条款和细则。请仔细查看任何您想要与之分享内容的应用的条款和细则。有些条款和细则可能会阻止您分享我们的内容。</p>-->
<!--    <p>对于您因任何超出我们合理控制范围的情况（包括但不限于任何传输、通信、电脑或其他设备故障，或者您因任何原因不能访问应用，或者在通过邮寄或任何电子媒介收发任何通知或讯息或说明时出现故障、错误或延迟）而产生的任何损失、损坏、费用、成本、延迟或责任（包括但不限于任何经济损失，如利润损失），我们将不对此承担责任。</p>-->
<!--    <p>2.5 版权</p>-->
<!--    <p>除另有说明外，本应用所有内容的相关权利均属于 Inter IKEA Systems B.V.，包括所有文字、说明和图片的版权等，以及包括名称和标志中的商标。</p>-->
<!--    <p>您可以从我们的应用上将摘要下载到本地硬盘并打印出来供您个人使用。您也可以将下载的摘要复制给其他人，但是您不得以营利为目的这样做。若非供个人使用，严禁以任何形式复制部分或全部内容。本应用的任何内容都不得以任何形式（无论是以硬拷贝、电子或其他形式） 复制或者以其他方式合并或存储到其他任何应用、电子检索系统、出版物或其他作品中。</p>-->
<!--    <p>如果您想将应用内容用于上述目的以外的其他目的（包括制作应用），您必须首先联系我们并征得我方同意。否则，除法律另有强制性规定外，未经宜家明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本应用的信息内容，否则宜家有权追究其法律责任。</p>-->
<!--    <p>2.6 确保您随时了解最新信息</p>-->
<!--    <p>我们随时保留更改与本应用和所提供的商品有关的条款的权利。我们对任何法律条款和细则的更改都将提前7天之前在应用上进行公示，并适用于未来对本应用的所有使用。您应该定期查看发布在本应用上的一般条款和细则以及我们的政策，因为它们可能会在您最后一次访问应用后有所更改。</p>-->
<!--    <p>2.7 您不能在本应用上做的事情</p>-->
<!--    <p>在使用我们的应用时，您不能：</p>-->
<!--    <p>(1)干扰或禁用任何与安全相关的应用功能或者阻止或限制使用或复制可从应用访问的内容的功能；</p>-->
<!--    <p>(2)在您的账户详情中提供虚假或误导性信息；</p>-->
<!--    <p>(3)在未征得他人允许的情况下盗用其身份或者以自己的身份来代表某个人、实体或组织；</p>-->
<!--    <p>(4)在我们暂停或禁止您使用应用后坚持使用本应用；</p>-->
<!--    <p>(5)发送垃圾信息或重复性信息；</p>-->
<!--    <p>(6)从事任何违法或非法行为；</p>-->
<!--    <p>(7)篡改、干扰、拦截、破坏或攻击应用；</p>-->
<!--    <p>(8)故意引入病毒、木马程序、蠕虫病毒、逻辑炸弹或其他类似程序，或者采取其他可能危害应用及任何应用用户的设备的行动来错误地使用应用，或者对任何应用用户的浏览体验产生不利影响；</p>-->
<!--    <p>(9)未遵守这些使用条款而从应用收集任何数据；</p>-->
<!--    <p>(10)提交或提供任何带有辱骂性、威胁性、淫秽性、不真实、不文明、庸俗的、骇人听闻或攻击性的内容；</p>-->
<!--    <p>(11)虐待、伤害或威吓其他应用用户、我们的员工或他人；</p>-->
<!--    <p>(12)在未征得内容所有者允许的情况下提交或提供任何用户内容或以其他方式侵犯版权、商标或第三方的其他权利；</p>-->
<!--    <p>(13)提交或提供关于他人的任何虚假、私人、机密性或诽谤性的信息或评论(包括以未经证实的犯罪行为或严重不当行为为由对他人进行人身攻击，这些行为可能会严重损害他们在任何阅读评论的人心目中的名誉)；或</p>-->
<!--    <p>(14)发表或转发可能会危害中华人民共和国国家安全或破坏社会安定的言论。</p>-->
<!--    <p>如果您违反使用条款中的任何内容，我们可能会永久或暂时阻止您使用本应用。我们还会采取其他措施，包括但不限于向警方或其他执法机构报案、发布警告或起诉您，并就我们因此而产生的任何成本向您提出索赔。</p>-->
<!--    <h3>3. 条款和细则</h3>-->
<!--    <p>3.1 合同缔结</p>-->
<!--    <p>如果您通过本应用订购商品，本应用上展示的商品和价格等信息仅仅是要约邀请，您的订单将成为订购商品的要约。收到您的订单后，我们将向您发送电子邮件或短信确认我们已收到您的订单，其中载明订单的细节，但该确认不代表我们接受您的订单。只有当我们向您发出发货确认的电子邮件或短信，通知您我们已将您订购的商品发出时，才构成我们对您的订单的接受，我们和您之间的订购合同才成立。如果您在一份订单里订购了多种商品，而我们只向您发出了其中部分商品的发货确认电子邮件或短信，那么我们和您之间的订购合同仅就该部分商品成立。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。宜家移动应用上的价格，声明和广告并不构成要约。在宜家移动应用接受您的订单之前，您和宜家移动应用之间不存在合同关系。宜家移动应用有权在发现显示的产品及订单的明显错误或产品缺货的情况下，单方面撤回该信息或终止交易。宜家移动应用保留对每位购物者订购产品的数量的限制权。这些限制可能针对来自同一帐号，同一收货地址的订单。</p>-->
<!--    <p>目前，宜家移动应用只向个人消费者提供产品或服务。如果宜家有证据表明或有合理理由怀疑某些订购行为并非出于个人或家庭使用之目的，则它有权取消任何订单。</p>-->
<!--    <p>3.2 产品价格</p>-->
<!--    <p>划线价格：正品零售价，门店、移动应用销售指导价等，并非原价，仅供参考。</p>-->
<!--    <p>未划线价格：商品的实时标价， 不因表述的差异改变性质。具体成交价格根据商品参加活动，是否是会员，或使用优惠券等发生变化，最终以订单结算价格为准。</p>-->
<!--    <p>产品详情页（含主图）以图片或文字形式标注的促销价、会员价等价格可能是在使用优惠券、满减或特定优惠活动和时段等情形下的价格，具体请以结算页面的标价、优惠条件或活动规则为准。</p>-->
<!--    <p>3.3 产品库存</p>-->
<!--    <p>因系统更新频率原因，查询到的门店库存仅供参考， 以商场实际为准。</p>-->
<!--    <p>在线上购物流程中，库存会因不同的送货地址、邮编、系统更新频率等影响，提供的库存可能存在差异。如在配送过程中，出现任何库存异常，我们客服中心会及时联系你，修改送货时间，或办理退换货等。</p>-->
<!--    <p>3.4 产品订单</p>-->
<!--    <ul>-->
<!--      <li>使用本应用下订单，您应具备购买相关商品的权利能力和行为能力，如果您在18周岁以下，您需要在父母或监护人的监护参与下才能使用本应用。在下订单的同时，即视为您满足上述条件，并对您在订单中提供的所有信息的真实性负责。</li>-->
<!--      <li>在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。</li>-->
<!--      <li>您理解并同意：本应用上展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向本应用发出的合同要约；本应用收到您的订单信息后，只有在宜家将您在订单中订购的商品从仓库实际直接向您发出时（以商品出库为标志），方视为您与本应用之间就实际直接向您发出的商品建立了合同关系；如果您在一份订单里订购了多种商品并且本应用只给您发出了部分商品时，您与本应用之间仅就实际直接向您发出的商品建立了合同关系；只有在本应用实际直接向您发出了订单中订购的其他商品时，您和本应用之间就订单中其他已实际直接向您发出的商品才成立合同关系。</li>-->
<!--      <li>尽管本应用做出最大的努力，但由于市场变化及各种以合理商业努力难以控制因素的影响，宜家无法避免您提交的订单信息中的商品出现缺货情况；如您下单所购买的商品发生缺货，您有权取消订单，宜家亦有权自行取消订单，若您已经付款，则为您办理退款。</li>-->
<!--    </ul>-->
<!--    <h3>4. 送货</h3>-->
<!--    <p>4.1 关于送货条款</p>-->
<!--    <p>此类送货条款仅在您使用我们的送货上门服务时适用。</p>-->
<!--    <p>我们将送货上门，并始终对送货上门服务的质量进行监督。</p>-->
<!--    <p>我们可能会随时更改这些送货条款。应该在使用我们的送货上门服务前查看送货条款。</p>-->
<!--    <p>4.2 我们将货送到哪里?</p>-->
<!--    <p>我们会将货物送到您提供给我们的送货地址。地点必须位于中华人民共和国境内（不包括香港、澳门及台湾地区），且通过公路即可到达。如有任何海上运输，我们会将货物运送至指定的承运人、运货代理商或中华人民共和国境内的港口地址。</p>-->
<!--    <p>4.3 送货限制条件</p>-->
<!--    <p>很遗憾，我们无法运送易逝性产品。</p>-->
<!--    <p>其中一些家具比您想象中要大，尤其是沙发。请检查您要购买的产品尺寸，以确保收货地址有充足的空间，待产品安装完后能够适合您的房间。送货前，请确保有充足的通道和空间，且任何楼梯和电梯均适合货物进入。您必须确保房屋和周围环境不会对送货人员构成危险。您应该搬走可能会在送货期间损坏的易碎物品，例如灯具、花瓶和照片。</p>-->
<!--    <p>我们将尽一切努力将产品送到您指定的房间内，条件是这样做是安全、实际的。但是，如果送货人员认为将产品送到该房间并不安全，在可能的情况下我们会与您协商将产品送到另一个房间。如果我们的送货人员认为将产品送到您指定的房间可能会对产品或房屋造成损坏，他们会告知您并在送货单上记录该问题。您仍可以接受此次送货但是我们将对产品或房屋的任何损坏不承担任何责任。然而，我们的送货人员将合理谨慎地配送产品。</p>-->
<!--    <p>我们的送货人员不允许也将不会:为了完成配送而移除门窗和门框等物件。您必须在配送前做好妥善安排。我们的送货人员不会携带任何专用起重设备，也不会取出或安装配送产品或者移除任何包装。我们的送货人员在交付时不会将鞋子脱下。如果您担心这样做可能会损坏您的地板，请确保您使用防护板将地板盖住。</p>-->
<!--    <p>4.4 我们需要您提供哪些信息?</p>-->
<!--    <p>当您安排配送时，我们会要求您提供一些信息。此类信息将记录在送货单中，然后会根据您指定的地址进行送货。如果您未向我们提供完整、正确或准确的信息或说明，我们可能会取消送货并向您发出书面通知。</p>-->
<!--    <p>宜家送货服务以邮编为准，请选择与送货地址匹配的准确邮编，以确保货物顺利送达。宜家的送货范围，收费，库存， 服务时间皆以邮编为准。 宜家不承担由于邮编和详细送货地址的错误或不准确导致的送货范围任何直接或间接后果。</p>-->
<!--    <p>您负责确保您可以接货。如果不能，必须有一位能够代表您接货的成年人，并且您同意我们按照他们的指示送货，就像您提出的指示一样。我们的送货人员不允许在产品被签收前丢下任何产品。如果您无法接货请尽快通知我们。我们不对因您的失误而造成的任何延迟送货承担任何责任。</p>-->
<!--    <p>货到时，我们会要求您检验产品、检查包装情况以及配送件数是否正确。我们将要求您签署送货单以进行确认。如果出现任何问题，您应该在送货单上进行记录。缺少的产品将被重新订购，损坏/错误的产品将予以退还及更换并且免费配送给您。如果您在产品中发现某个问题，这将不影响您在未来的一段合理期限内向我们发出通知的法定权利。如果您拒签送货单，这将被视为您拒收货品。</p>-->
<!--    <p>4.5 如果您在交货后发现产品损坏该怎么办?</p>-->
<!--    <p>如果包装里的产品发现损坏，请在收货后 7 日内拨打电话通知宜家客户服务处，并在交货后尽快记录到送货单上。请妥善保留任何损坏产品，以便我们在日后进行检查。如果您在我们尚有机会检测前处理了任何损坏产品，这可能会对后续提供的售后服务产生影响。检测后，如果我们对配送产品的损坏负有责任，我们将给您提供售后服务，如果我们无法维修，则会全额退还您之前购买产品所支付给我们的款项和任何运费。如果任何产品在配送过程中因您的错误或过失而损坏，我们将不对此类产品承担责任。</p>-->
<!--    <p>4.6 送货日期</p>-->
<!--    <p>我们对许多地区（非全部地区）都提供“隔日送货”服务。对于某些地区，送货上门服务仅限于每周的固定几天。“隔日”送货服务有每日的截单时间，订货需求量和业务繁忙时期可能会限制我们提供“隔日送货”服务。我们在某些情况下提供下一个可用的送货时段。</p>-->
<!--    <p>4.6.1 您在本应用购买的商品将按照本应用上您所指定的送货地址进行配送。送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。您应当清楚准确地填写您的送货地址、联系人及联系方式等配送信息，您知悉并确认，您所购买的商品应仅由您填写的联系人接受身份查验后接收商品，因您变更联系人或相关配送信息而造成的损失由您自行承担。</p>-->
<!--    <p>4.6.2 因如下情况造成订单延迟或无法配送等，宜家将无法承担迟延配送的责任：</p>-->
<!--    <ul>-->
<!--      <li>客户提供错误信息，不详细的地址。</li>-->
<!--      <li>客户提供地址不在本应用声明的范围内。</li>-->
<!--      <li>货物送达无人签收，由此造成的重复配送所产生的费用及相关的后果。</li>-->
<!--      <li>不可抗力，例如：自然灾害、交通戒严、突发战争等。</li>-->
<!--    </ul>-->
<!--    <p>4.6.3 如果您因为个人原因改变原定送货日期，请在原定送货时间前一日提出，并应在原定送货时间往后七日之内再次选择并完成您的送货服务，具体日期以宜家客服和您联系后商定的日期为准；</p>-->
<!--    <p>4.6.4 因如下情况造成无法配送的，已收取的配送费用将不退还。如须再次送货，需要承担合理的二次配送费用：</p>-->
<!--    <ul>-->
<!--      <li>因个人原因改变原定送货日期，但未能在原定送货日期至少提前一日前提出的。</li>-->
<!--      <li>客户提供错误信息，不详细的地址。</li>-->
<!--      <li>货物于约定的送货日期送达却无人签收。</li>-->
<!--    </ul>-->
<!--    <p>4.7 运费及送货</p>-->
<!--    <p>运费是根据所配送的产品体积和重量计算的，适用于网上服务所示的送货范围。运费是以送货到单个房屋或地址为基础收取的。送货范围及运费可在线咨询。促销的客户运费将由我们自行决定是否使用，可能在预订前随时撤销。 您必须在预订时支付运费。付款后，我们将向您提供包含送货详情的送货单。我们会尽全力根据送货单 上指定的送货时段和日期将所有产品运送到指定地址。</p>-->
<!--    <p>4.8 更改订单、送货日期及取消送货</p>-->
<!--    <p>如果您的产品尚未配送，您可以更改订单订单和/或送货时间及日期，您也可以取消送货。请注意，任何“定制”产品在确认后都不能随时取消。如果您更改或取消订单，您只需支付在更改或取消时间之前产生的合理费用。如果您在预约的送货日期当天更改送货时间的，需要承担合理的二次配送费用。但是，如果更改或取消是因为我们未遵守送货条款而引起的，则您无需对我们因此类更改或取消所产生的费用承担任何责任。如因您的原因导致无法配送三次以上，或者经多次联系您无人接听/无法接通/停机且在约定的配送时间送货至预留的配送地址实际无人等导致无法完成的情况，我们有权单方取消订单</p>-->
<!--    <h3>5. 组装服务</h3>-->
<!--    <p>5.1 关于组装服务内容</p>-->
<!--    <p>宜家提供有偿的商品组装服务 。您可以联系宜家客户服务部门预订组装服务。</p>-->
<!--    <ul>-->
<!--      <li>线上购物的部分送货区域内，宜家提供送装同步服务。</li>-->
<!--      <li>如果您因为个人原因改变原定组装日期（针对非厨房或浴室家具），请在原定组装时间前一日提出，并应在原定组装时间往后七日之内再次选择并完成您的组装服务，具体日期以宜家客服和您联系后商定的日期为准；</li>-->
<!--      <li>如果您因为个人原因改变原定安装日期（针对厨房或浴室家具），请在原定安装时间前一日提出，并应在原定安装时间往后31日之内再次选择并完成您的安装服务，具体日期以宜家客服和您联系后商定的日期为准；</li>-->
<!--      <li>应用活动期间，会员商品及活动商品的服务费用将按商品原价收取</li>-->
<!--      <li>出于安全考虑，高度超过75厘米的着地柜体以及高度超过60厘米的儿童家具，建议您上墙安装。如果您已经办理了宜家组装服务，此上墙安装将包含在内。</li>-->
<!--      <li>非实心墙体及某些墙面（马赛克墙面、大理石墙面、玻化砖墙面、钢化砖墙面、空心砖墙面、石膏版墙面、保温墙墙面、隔音墙墙面和硅藻泥墙面）不提供 上墙服务。</li>-->
<!--      <li>如因经多次联系您无人接听/无法接通/停机且在约定的组装日期至预留的组装地址实际无人导致无法完成服务等情况，我们有权单方取消订单</li>-->
<!--    </ul>-->
<!--    <h3>6. 退货政策</h3>-->
<!--    <p>您可以改变您的想法，您在宜家获得愉悦的购物体验对于我们而言至关重要。如果您对产品不甚满意，您可在60天内（宜家会员俱乐部顾客365天内），携带完好的货品、原始包装和原始购物凭证（银行卡付款需要银行卡消费凭证）联系宜家客户服务部门申请退货。对于符合条件的申请，我们将按照您购物时的支付方式退款。</p>-->
<!--    <p>在符合《消费者权益保护法》等法律法规强制性规定的前提下，食品、贴身用品、植物、处理商品，定制商品、家用电器商品、以及被切割、裁剪和油漆过的产品或其他不适宜退还货的情况等，不适用于以上条例。</p>-->
<!--    <p>* 以上退换货政策仅适用中国大陆的宜家商场购买的货品。</p>-->
<!--    <h3>7. 所有其他法律信息</h3>-->
<!--    <p>7.1 保修</p>-->
<!--    <p>宜家应用上发布的产品说明以及配送产品随附的产品说明都会提供详细的保修权利介绍。此类保修不属于且不影响您作为客户的法定权利。</p>-->
<!--    <p>7.2 适用法律</p>-->
<!--    <p>通过访问本应用，您同意本使用条件以及您和本应用之间发生的任何争议均适用中华人民共和国法律。</p>-->
<!--    <p>7.3 争议</p>-->
<!--    <p>有关与您使用本应用或通过本应用购买的商品或服务的任何形式的争议应提交上海国际仲裁中心依照其届时有效之仲裁规则在上海进行仲裁。</p>-->
<!--    <p>7.4 责任限制</p>-->
<!--    <p>7.4.1 除法律禁止外，我们不对任何间接的、衍生的、惩戒的、附带的或惩罚性损害 （包括但不限于利润损失、收入损失、合约损失、耗费的支出）承担责任，即使宜家已被告知可能发生该等损害。对于超出我们控制范围的情况所导致的任何违反条款和细则的行为，除法律禁止外，我方将不对此承担责任。如果我们违反此类条款和细则我们将只对您承受的直接损失负责，且这些直接损失是指您从本应用购买产品或服务之时可以合理预见的损失。</p>-->
<!--    <p>7.4.2 我们努力为您提供优质的服务，但我们不对因信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。</p>-->
<!--    <p>7.4.3 如果宜家发现或收到他人举报投诉您违反本协议约定，本应用有权不通知且随时对相关内容进行删除，屏蔽，并根据具体行为对违规账号处以包括但不限于警告，限制，或者禁止功能，直至注销的处罚。宜家有权合理判断对违反相关法律或本协议约定的行为采取适当的法律措施，并依据法律法规保存相关证据向有关部门报备，您应独自承担由此而产生的一切法律责任及费用。</p>-->
<!--    <p>7.5 赔偿</p>-->
<!--    <p>对于任何第三方向宜家提出的，因您使用本应用而产生的或与之有关的任何请求、损失、责任、主张或费用（包括律师费），您同意赔偿宜家及其管理人员、董事、股东、前任、利益承继人、员工、代理人、子公司和关联方，并使其免受损害。</p>-->
<!--    <p>7.6 应用政策、修改和可分性</p>-->
<!--    <p>请阅读本应用上发布的其他政策。这些政策同样适用于您对本应用的访问。我们保留在任何时候对本应用、政策和本使用条件作出修改的权利，而您同意接受该等随时作出的修订。如果本使用条件中任何一条被视为废止、无效或因任何理由不可执行，该使用条件应视为可分割的且不影响任何其余条款的有效性和可执行性。</p>-->
<!--    <h3>8. 设备连接</h3>-->
<!--    <p>8.1 访问我们的应用</p>-->
<!--    <p>我们不断致力于提高本应用的质量，并使所有用户都能够访问应用。</p>-->
<!--    <p>8.2 设备连接功能</p>-->
<!--    <p>8.2.1 更改字体大小</p>-->
<!--    <p>本应用中使用的样式表允许您更改字体大小。你应该遵照浏览器上的说明来更改字体大小。</p>-->
<!--    <p>8.2.2 通过访问我们的应用购买商品等服务</p>-->
<!--    <ul>-->
<!--      <li>您需要自行配备上网的所需设备，包括个人手机、平板电脑、笔记本电脑，台式电脑，调制解调器、路由器等。</li>-->
<!--      <li>您需要自行负担个人上网所支付的与此服务有关的电话费用、网络费用等。</li>-->
<!--      <li>您需要选择与安装适当且相匹配的系统及浏览器。</li>-->
<!--    </ul>-->
<!--    <h3>9. 联系我们:</h3>-->
<!--    <p>如果您在访问本应用时遇到任何难题，请告知我们以进行改进，欢迎发送电子邮件至CS.CNIKEA@IKEA.COM 或拨打 400-800-2345 。</p>-->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    if (window.injectProperty && window.injectProperty.prerender) {
      return;
    }
    window.location.replace(`/modules/cms/universal/landing-page.html?key=45af15754a42451f8ce3e49142a85696`);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/app/TermsAndConditions.vue